'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMRadioButtonsRow = require('./OMRadioButtonsRow.scss');var styles = _interopRequireWildcard(_OMRadioButtonsRow);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMRadioButtonsRow = function OMRadioButtonsRow(props) {var
  values = props.values,name = props.name,selectedValue = props.selectedValue,className = props.className;

  var renderItem = function renderItem(item) {var _cx;var
    value = item.value,label = item.label;
    var handleChange = function handleChange() {return props.onChange(value);};

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          styles.segmentedButton, (_cx = {}, _cx[
          styles.active] = selectedValue == value, _cx)),

          key: label },

        _react2.default.createElement('input', {
          name: name,
          type: 'radio',
          value: value,
          id: name + '-' + value,
          onChange: handleChange }),

        _react2.default.createElement('label', { htmlFor: name + '-' + value }, label)));


  };

  return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.segmentedWrapper, className) },
      values.map(renderItem)));


};

OMRadioButtonsRow.propTypes = {
  values: _propTypes2.default.array,
  name: _propTypes2.default.string,
  selectedValue: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func };exports.default =


OMRadioButtonsRow;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMRadioButtonsRow/OMRadioButtonsRow.js
// module id = 1221
// module chunks = 0